<!-- ======= Header ======= -->
<header id="header" class="fixed-top">
	<div class="container  align-items-center logo1">
		<div class="row">
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<h1 class="logo mr-auto img-responsive"><img src="./assets/images/landing-img/equitas-img/equitas-desktop.png" alt="HDFC securities."></h1>
			</div>
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<h1 class="logo mr-auto img-responsive fr mt"><a href="https://www.hdfcsec.com/" target="_blank"><img src="./assets/images/landing-img/equitas-img/hsl_logo.png" alt="HDFC securities."></a></h1>
			</div>
		</div>
	</div>
	<div class="container  align-items-center logo2">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
				<h1 class="logo mr-auto img-responsive "><a href="https://www.hdfcsec.com/" target="_blank"><img src="./assets/images/landing-img/equitas-img/equitas-mobile.png" alt="HDFC securities." class="HE"></a></h1>
			</div>

		</div>
	</div>
</header>
<!-- End Header -->

<main id="main">
	<section class="bgmain">
		<div class="container">
			<div class="row wow fadeInDown" data-wow-delay="300ms">
				<div class="col-sm-12 col-md-6 col-lg-7">
					<h1 class="open"><span style="color:#e40010;">All-in-1 </span>Investment account</h1>

					<span class="intro"><img class="img-responsive intro" alt="Become a referral partner " src="./assets/images/landing-img/equitas-img/LP_GIF.gif" data-holder-rendered="true"></span>
				</div>
				<div class="clearfix"></div>

				<div class="col-lg-5 col-md-6 col-sm-12 wow zoomIn" data-wow-delay="1100ms">
					<form>

						<div class="formcontainer">

							<div class="container">
								<h1 class="rg">Your digital doorway to financial freedom</h1>

								<div class="form-group">
									+91 |
									<input type="tel" class="form-control MN" style="height:45px; display:inline-block;" placeholder="Your 10 digit mobile number" id="txtMobile" name="txtMobile" [(ngModel)]="loginDetails.Mobile" maxlength="10" onkeypress="return !isNaN(event.key) || event.charCode == 13" autocomplete="off" required />
								</div>
								<div class="form-group">
									<input type="text" placeholder="Referral/Employee/RM Code" name="name" class="form-control alphanumeric" style="height:45px" required [(ngModel)]="lcCode" maxlength="50">
								</div>
								<!--<div class="form-group" style="display:none;">
									<input type="text" placeholder="OTP" name="otp" class="form-control" maxlength="6" style="height:45px" required>


									<span class="psw"><a href="#" style="text-decoration:underline;float:right;padding:3px 0px"> Get New OTP</a></span>
								</div>-->
								<div class="form-group">
									<input type="checkbox" id="chkDeclaration" name="chkDeclaration" checked [(ngModel)]="declaration">
									<span class="checkmark"></span>
									<h5 style="text-align:center;margin:0 auto;font-size:15px;display:inline-block; margin-left: 5px;"> I accept the <a data-toggle="modal" href="#myModal"><u>Terms & Conditions</u></a> </h5>
								</div>

								<div class="form-group">
									<button type="submit" class="btn btn-danger btn-lg startj" (click)="doLogin()">Start Journey</button>
								</div>
								<div class="form-group">

									<span class="ct">
										Keep these details handy<br>
										Pan Card | Aadhar Number | Bank A/c details
										.
									</span>
								</div>
							</div>
						</div>


					</form>

				</div>
			</div>

		</div>
	</section>
	<!-- End Breadcrumbs -->
	<section>
		<div class="container">
			<footer id="footer" class="wow fadeInUp" data-wow-delay="1200ms">
				<div class="container d-md-flex pro py-4">
					<div class="mr-md-auto text-center text-md-left">
						<div class="copyright">
							<span>HDFC securities Ltd.</span>
							<div class="credits">
								<p>
									Investment in securities market are subject to market risks, read all the related documents carefully before investing.Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. Mutual fund investments are subject to market risks, read all scheme related documents carefully.
									<br />
									<br />
									SEBI Registration No.: INZ000186937 (NSE, BSE,MSEI, MCX) |NSE Trading Member Code: 11094 | BSE Clearing Number: 393 | MSEI Trading Member Code: 30000 | MCX Member Code: 56015 | IN-DP-372-2018 (CDSL, NSDL) | CDSL DP ID: 12086700 | NSDL DP ID: IN304279 | AMFI Reg No. ARN -13549 | PFRDA Reg. No - POP 11092018 | IRDA Corporate Agent Licence No.CA0062 | Research Analyst Reg. No. INH000002475 | Investment Adviser: INA000011538 | CIN-U67120MH2000PLC152193 Registered Address: I Think Techno Campus, Building, B, Alpha, Office Floor 8, Near Kanjurmarg Station, Kanjurmarg (East), Mumbai -400 042. Tel -022 30753400. Compliance Officer: Mr. Murli V Karkera. Ph: 022-3045 3600, Email: complianceofficer@hdfcsec.com. <br />
									<br />
									Disclaimer: HDFC Securities Ltd. is a financial services intermediary and is engaged as a distributor of financial products & services like Corporate FDs & Bonds, Insurance, MF, NPS,Real Estate services, Loans, NCDs, IPOs, E-Will & E-Tax in strategic distribution partnerships. Customers need to check products & features before investing since the contours of the product rates may change from time to time. HDFC securities Ltd. is not liable for any loss or damage of any kind arising out of investments in these products. Investments in Equity, Currency, Futures & Options are subject to market risk. Clients should read the Risk Disclosure Document issued by SEBI & relevant exchanges & the T&C on www.hdfcsec.com before investing. Global Investing, Digigold, Insurance, Mutual Funds and NPS are not an approved product of the Exchanges and any dispute related to this will not be dealt at Exchange platform. MTF is subject to the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd. <br />
									<br />
									Please note that by submitting the above mentioned details, you are authorising us/your referral partner to call you even though you may be registered under DNC.
									<br />
									<br />
									<br />

									<a data-toggle="modal" href="#exampleModalLong" style="color:#fff;font-size:13px;text-decoration:underline;padding:0px;text-align:center;margin:0 auto;display:block;">Disclaimer</a>
								</p>

							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	</section>

</main>
<!-- End #main -->
<!-- ======= Footer ======= -->
<!-- End Footer -->
<!-- Modal terms conditions -->
<div class="modal fade bd-example-modal-lg" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalTitle" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="myModalTitle wow fadeInUp" data-wow-delay="1000ms"> Terms & Conditions </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
			</div>
			<div class="modal-body">
				<p>  I/We hereby authorize HDFC Securities Limited to disclose details of my/our account as mentioned in the account opening form, supporting documents submitted therewith and/or any other information pertaining to my/our account including the trades/transactions carried out through my/our account to the Referral Partner/Authorized Person/Alliance Partner affiliated to HDFC Securities Limited.</p>

			</div>
		</div>
	</div>
</div>





<!-- Modal disclamer-->
<div class="modal fade bd-example-modal-lg" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLongTitle wow fadeInUp" data-wow-delay="1000ms"> Disclaimer </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
			</div>
			<div class="modal-body">
				<p> Investment in securities markets are subject to market risks, read all the related documents carefully before investing.</p>
				<p>Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.</p>
				<p>Mutual fund investments are subject to market risks, read all scheme related documents carefully.</p>

				<p>
					<b>SEBI Registration No.:</b> INZ000186937 (NSE, BSE, MSEI, MCX)<br />
					<b>NSE Trading Member Code:</b> 11094<br />
					<b>BSE Clearing Number:</b> 393<br />
					<b>MSEI Trading Member Code:</b> 30000<br />
					<b>MCX Member Code:</b> 56015 IN-DP-372-2018 (CDSL, NSDL)<br />
					<b>AMFI Reg No.:</b> ARN -13549<br />
					<b>PFRDA Reg. No.:</b> POP 11092018<br />
					<b>IRDA Corporate Agent Licence No.:</b> CA0062<br />
					<b>Research Analyst Reg. No.:</b> INH000002475<br />
					<b>Investment Adviser:</b> INA000011538 CIN-U67120MH2000PLC152193
				</p>
				<p>
					<b>Registered Address:</b> I Think Techno Campus, Building, B, Alpha, Office Floor 8, Near Kanjurmarg Station, Kanjurmarg (East), Mumbai -400 042. Tel:<a href="tel:02230753400" target="_blank"> <b>022 30753400</b></a>.<br />
					<b>Compliance Officer:</b><br />
					Mr. Murli V Karkera. Ph: <a href="tel:02230453600" target="_blank"><b>022 30453600</b></a>,<br />
					Email: <a href="mailto:complianceofficer@hdfcsec.com" target="_blank"><b>complianceofficer@hdfcsec.com</b></a>.<br />
				</p>
				<p><b>Disclaimer :</b> HDFC Securities Ltd is a financial services intermediary and is engaged as a distributor of financial products & services like Corporate FDs & Bonds, Insurance, MF, NPS, Real Estate services, Loans, NCDs, IPOs, E-Will & E-Tax in strategic distribution partnerships.</p>
				<p>Customers need to check products & features before investing since the contours of the product rates may change from time to time. HDFC securities Ltd is not liable for any loss or damage of any kind arising out of investments in these products.</p>
				<p>Investments in Equity, Currency, Futures & Options, Commodities are subject to market risk.</p>
				<p>Clients should read the Risk Disclosure Document issued by SEBI & relevant exchanges & the T&C on <a href="https://www.hdfcsec.com/" target="_blank">www.hdfcsec.com</a> before investing. Equity SIP is not an approved product of Exchange and any dispute related to this will not be dealt at Exchange platform. </p>
			</div>
		</div>
	</div>
</div>
